import { MiniCart } from './miniCart.js';
import { myNoipDisplayCorrection, hideError } from './miniCartUiHelpers';

export class MiniCartController {
  constructor() {
    this.miniCart = new MiniCart();
    this.loading = false;
  }

  init() {
    // eslint-disable-next-line no-unused-vars
    this.miniCart.loadCart().then(json_data => {
      this.bindAllEvents();
    });
  }

  bindAllEvents() {
    this.bindCartButtonDisplayEvents();
    this.bindOutsideCartCloseEvents();
    this.bindAddEvents();
    this.bindDeleteEvents();
    this.bindMyNoipDisplayCorrection();
    this.bindHideError();
  }

  bindMyNoipDisplayCorrection() {
    myNoipDisplayCorrection();
  }

  bindCartButtonDisplayEvents() {
    document.querySelectorAll('.pb-cart').forEach(node => {
      node.addEventListener(
        'click',
        () => {
          this.displayCart();
        },
        true
      );
    });
  }

  bindOutsideCartCloseEvents() {
    document.addEventListener('click', function (event) {
      let openMinicart = document.querySelectorAll('div.container.pb-cart-container.in').length;

      if (!openMinicart) {
        return;
      }

      let clickedElement = event.target;

      let clickInsideMiniCart = false;

      let isCtaButton = !!clickedElement.getAttribute('data-product') || clickedElement.name === 'legacy-domain-reg-wizard-add-to-cart';

      let isCartButton = clickedElement.classList.contains('cart') && clickedElement.classList.contains('nav-link');

      // Check if it is the scrolled header button in shortstar
      if (!isCartButton) {
        isCartButton = clickedElement.classList.contains('pb-cart');
      }

      let isNumItemIcon = clickedElement.classList.contains('badge-cart-items') && clickedElement.tagName === 'SPAN';

      clickInsideMiniCart = clickedElement.getParentElements().some(node => {
        return node.classList.contains('pb-cart-container');
      });

      // Hide mini cart and remove active from button and anchor tag
      if (!isCtaButton && !isCartButton && !clickInsideMiniCart && !isNumItemIcon) {
        document.querySelector('div.container.pb-cart-container').classList.remove('in');
        document.querySelectorAll('.pb-cart').forEach(node => {
          node.classList.remove('active');
        });
      }
    });
  }

  bindHideError() {
    let dismissButton = document.getElementById('dismiss-error-button');

    if (typeof dismissButton == 'undefined' || dismissButton == null) {
      return;
    }

    dismissButton.addEventListener(
      'click',
      () => {
        hideError();
      },
      false
    );
  }

  bindAddEvents() {
    // Here we bind the event to the document so that elements rendered after this event is bound will be handled
    // automatically. The parents need to be walked - looking for [data-product] - so that `<a><i class="fa"></a>`
    // or similar will continue to work as expected
    document.addEventListener(
      'click',
      event => {
        let node = event.target ? event.target.closest('[data-product]') : null;

        if (!node || !node.hasAttribute('data-product')) {
          return;
        }

        if (node.tagName !== 'BUTTON' && node.tagName !== 'A') {
          return;
        }

        let add_domain_modal_is_showing = false;

        // If we're showing the add domain modal, don't show the mini cart too
        if (node.classList.contains('plus')) {
          let data_product = node.getAttribute('data-product');
          add_domain_modal_is_showing = data_product === '';
        }

        if (!node.hasAttribute('data-link-to-pb') && !add_domain_modal_is_showing) {
          event.preventDefault();
          this.openMiniCart();
        }

        this.miniCart.addItems(node.getAttribute('data-product')).then(() => {
          if (node.hasAttribute('data-link-to-pb')) {
            window.location = node.getAttribute('data-link-to-pb');
            return;
          }
          this.bindDeleteEvents();
          this.bindHideError();
        });
      },
      false
    );
  }

  bindDeleteEvents() {
    document.querySelectorAll('button.delete.btn.btn-xs.btn-flat.btn-outline.btn-danger.pr-lg').forEach(node => {
      node.addEventListener(
        'click',
        e => {
          e.preventDefault();
          this.miniCart.deleteItem(node.getAttribute('data-item_id')).then(() => {
            this.bindDeleteEvents();
          });
        },
        false
      );
    });
  }

  displayCart() {
    if (!this.isDisplayed()) {
      this.openMiniCart();
    } else {
      this.closeMiniCart();
    }
  }

  openMiniCart() {
    document.querySelector('div.container.pb-cart-container').classList.add('in');
    document.querySelectorAll('.pb-cart').forEach(node => {
      node.classList.add('active');
    });
  }

  closeMiniCart() {
    document.querySelector('div.container.pb-cart-container').classList.remove('in');
    document.querySelectorAll('.pb-cart').forEach(node => {
      node.classList.remove('active');
    });
  }

  isDisplayed() {
    return document.querySelector('div.container.pb-cart-container').classList.contains('in');
  }
}

// Parents helper
// Pulled from https://gist.github.com/ziggi/2f15832b57398649ee9b
Element.prototype.getParentElements = function (selector) {
  var elements = [];
  var elem = this;
  var ishaveselector = selector !== undefined;

  while ((elem = elem.parentElement) !== null) {
    if (elem.nodeType !== Node.ELEMENT_NODE) {
      continue;
    }

    if (!ishaveselector || elem.matches(selector)) {
      elements.push(elem);
    }
  }

  return elements;
};
